import React from 'react';
import styled from 'styled-components';
import {P2, ValueTitle} from "../Kit/Kit";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
  
  @media(min-width: 768px){
    margin-bottom: 0;
  }
`;

const LetterBox = styled.div`
  font-family: Cabin-Bold, sans-serif;
  font-size: 80px;
  color: #fff;
  background-color: #90d2e4;
  width: 40vw;
  height: 40vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  
  @media(min-width: 768px){
    font-size: 60px;
    width: 10vw;
    height: 10vw;
    margin-bottom: 32px;
  }
  
  @media(min-width: 992px){
    font-size: 140px;
    width: 15vw;
    height: 15vw;
  }
  
  @media(min-width: 1200px){
    font-size: 180px;
    //width: 280px;
    //height: 280px;
  }
`;

const ValueDescription = P2.extend`
  margin-top: 8px;
  
  @media(min-width: 768px) {
    margin-top: 16px;
  }
`;

const ValueCards = (props) => {
    const {letter, title, description} = props;
    return (
      <Container>
          <LetterBox>{letter}</LetterBox>
          <ValueTitle>{title}</ValueTitle>
          <ValueDescription>{description}</ValueDescription>
      </Container>
    );
};

export default ValueCards;



// WEBPACK FOOTER //
// ./src/components/GetToKnow/ValueCards.js